// Returns true if Debug is enabled (only in development mode)
export const isDebugEnabled = () => document.documentElement.dataset.debug === 'true'

// Returns true if debug console is enabled (only in development mode)
export const isDebugConsoleEnabled = () => document.documentElement.dataset.debugConsole === 'true'
